import { FeedbackComponent } from '@core/feedback/feedback.component'
import { NotificationsComponent } from '@core/infra/notifications/notifications.component'

// The one fixed top-right container — both are plain block-level content, so
// if they're ever both visible at once they stack instead of overlapping.
export const TopRightStackComponent = () => (
  <div className="fixed top-4 right-4 z-50 flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-y-2">
    <FeedbackComponent scope="app" />
    <NotificationsComponent />
  </div>
)
